import Repository from './Repository.js'
import querystring from 'querystring'

export const isSuccessful = (response) => {
  return response.data && response.status >= 200 && response.status < 400
}

export default {
  login(username, password, rememberMe) {
    return Repository.post('login', querystring.stringify({
      username: username,
      password: password,
      remember_me: rememberMe
    }))
  },
  getSite(id_site, id_link) {
    if (!id_site && !id_link) {
      return Promise.reject('OHMRepository: one of id_site and id_link must be set')
    }

    const q = {}
    if (id_site) {
      q['id_site'] = id_site
    }
    if (id_link) {
      q['id_link'] = id_link
    }
    return Repository.get('site?' + querystring.stringify(q))
  },
  getHintFunctions() {
    return Repository.get('hintfunctions')
  },
  getHintFunctionMap() {
    return Repository.get('hintfunctions/map')
  },
  getHints(id_site, id_link) {
    if (!id_site && !id_link) {
      return Promise.reject('OHMRepository: one of id_site and id_link must be set')
    }

    const q = {}
    if (id_site) {
      q['id_site'] = id_site
    }
    if (id_link) {
      q['id_link'] = id_link
    }
    return Repository.get('hints?' + querystring.stringify(q))
  },
  saveHints(hints, id_site, id_link) {
    if (!id_site && !id_link) {
      return Promise.reject()
    }

    let q = {}
    if (id_site) {
      q['id_site'] = id_site
    }
    if (id_link) {
      q['id_link'] = id_link
    }

    let data = []
    hints.forEach(h => {
      data.push({
        link_filter_id: h.id,
        statements: h.statements
      })
    })
    data = JSON.stringify(data)
    return Repository.post(`hints?` + querystring.stringify(q), querystring.stringify({ data: data }))
  },
  saveBlob(blob, link_filter_id) {
    if (!link_filter_id) {
      return Promise.reject('link_filter_id must be set')
    }

    return Repository.post(`blob`, querystring.stringify({ link_filter_id, blob }))
  },
  reclassify(id_site, id_link, keepText) {
    return Repository.post(`reclassify/${id_link}?keeptext=${keepText ? 1 : 0}`)
  },
  getLatest(id_site, id_link) {
    if (!id_site && !id_link) {
      return Promise.reject()
    }

    let q = {}
    if (id_site) {
      q['id_site'] = id_site
    }
    if (id_link) {
      q['id_link'] = id_link
    }

    return Repository.get(`articles?` + querystring.stringify(q))
  },
  getArticleDates(id_link) {
    return Repository.get(`article/${id_link}/dates`)
  },
  getHintImpact(id_link) {
    return Repository.get(`impact/hint/${id_link}`)
  },
  getArticleHintImpact(id_site) {
    return Repository.get(`impact/article/${id_site}`)
  },
  getStatementArticleImpact(id_site, crc32, id_links) {
    return Repository.get(`impact/article/${id_site}/${crc32}?articles=${id_links.join(',')}`)
  },
}
